import { ThemedText } from "@/components/ThemedText";
import { PRIVACY_URL, TERMS_URL } from "@/utils/legalUrls.web";
import { useTranslation } from "react-i18next";
import { Linking } from "react-native";

interface AuthTermsNoticeProps {
  // Leading sentence key; differs by flow (login vs signup).
  introKey: string;
}

export function AuthTermsNotice({ introKey }: AuthTermsNoticeProps) {
  const { t } = useTranslation();

  return (
    <ThemedText className="mt-4 text-xs text-center text-gray-600">
      {t(introKey)}{" "}
      <ThemedText
        className="text-xs text-blue-600 underline"
        onPress={() => Linking.openURL(TERMS_URL)}
      >
        {t("TERMS_AND_CONDITIONS")}
      </ThemedText>{" "}
      {t("AND")}{" "}
      <ThemedText
        className="text-xs text-blue-600 underline"
        onPress={() => Linking.openURL(PRIVACY_URL)}
      >
        {t("PRIVACY_POLICY")}
      </ThemedText>
      .
    </ThemedText>
  );
}
